
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/dove-dormire",
      function () {
        return require("private-next-pages/[region]/[resort]/dove-dormire.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/dove-dormire"])
      });
    }
  